"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const GaDataStore_1 = __importDefault(require("../../stores/GaDataStore"));
const StoresUtil_1 = require("../../util/StoresUtil");
let GDPRSignersModal = class GDPRSignersModal extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dealerConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "opened", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "onContinueClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.opened = false;
            }
        });
        Object.defineProperty(this, "onClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                GaDataStore_1.default.pushAnalyticsObject('GDPR Signer modal', 'Button - gdpr-signer-modal-cancel');
                this.opened = false;
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.Modal, { onClose: this.onClose, isOpen: this.opened, hasContentComponent: true, size: "6-col" },
            react_1.default.createElement(lib_1.ModalContent, null,
                react_1.default.createElement("div", { className: "text" },
                    react_1.default.createElement("h1", null, translate('gdpr.signers.modal.title')),
                    react_1.default.createElement("p", null, translate('gdpr.signers.modal.description')),
                    this.renderStipulation(),
                    react_1.default.createElement(lib_1.ChoiceGroup, { id: "gdpr-signers-choice", type: "check", label: "Vali esindajad", options: this.renderRows(), defaultValue: this.dealerConsentStore.allConsentSigners.map((s, i) => (s.selected ? i.toString() : '')), onChange: (value) => {
                            if (!!value) {
                                this.dealerConsentStore.allConsentSigners.forEach((signer, index) => (signer.selected = value.includes(index.toString())));
                            }
                        } }),
                    react_1.default.createElement(lib_1.Separator, { spacing: "small", color: "invisible" }),
                    react_1.default.createElement("p", { className: "text-center" },
                        react_1.default.createElement(GaButton_1.default, { id: "gdpr-signers-modal-continue", type: "employee", text: translate('gdpr.signers.modal.continue'), iconRight: "#arrow-right", disabled: this.dealerConsentStore.selectedConsentSigners.length === 0, onClick: this.onContinueClick }))))));
    }
    renderRows() {
        return this.dealerConsentStore.allConsentSigners.map((signer, index) => {
            return {
                id: `rep-${index}`,
                labelText: `${signer.firstName} ${signer.lastName} - ${signer.personalCode}`,
                value: `${index}`,
                disabled: this.ssoStore.isSamePerson(signer.personalCode),
                checked: signer.selected || false
            };
        });
    }
    renderStipulation() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement("p", null,
            translate('gdpr.signers.modal.stipulation'),
            "\u00A0",
            this.dealerConsentStore.allConsentSigners[0].representationStipulation));
    }
};
__decorate([
    mobx_1.observable
], GDPRSignersModal.prototype, "opened", void 0);
__decorate([
    mobx_1.action
], GDPRSignersModal.prototype, "onContinueClick", void 0);
__decorate([
    mobx_1.action
], GDPRSignersModal.prototype, "onClose", void 0);
GDPRSignersModal = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRSignersModal);
exports.default = GDPRSignersModal;
